import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs } from 'vue';
import { EMIT } from '@/enum';
import { useTenantIntegrationStore } from '@/store';

interface PropsInterface {
  data?: null;
  integration?: null;
  tenantId: number | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolDaySISOrganizationsActions',
  props: {
    data: { default: null },
    integration: { default: null },
    tenantId: { default: null }
  },
  emits: [EMIT.UPDATE],
  setup(__props: any, { emit: __emit }) {

const tenantIntegrationStore = useTenantIntegrationStore();

const props = __props;

const { data, integration, tenantId } = toRefs(props);

const emit = __emit;

const createMenuModel = (item) => {
  return [
    {
      label: 'Sync Data',
      icon: {
        name: 'sync',
        styles: 'inline-block text-lg',
      },
      styles: '',
      command: () => onSync(item.id),
    },
    {
      label: 'Edit Connection',
      icon: {
        name: 'person',
        styles: 'inline-block text-lg',
      },
      styles: '',
      command: () => onEdit(item.id),
    },
    {
      label: 'Remove Connection',
      icon: {
        name: 'vpn_key',
        styles: 'inline-block text-lg',
      },
      command: () => onRemove(item.id),
    },
  ];
};

const onSync = () => emit(EMIT.SYNC);

const onEdit = (id: number) => emit(EMIT.UPDATE, id);

const onRemove = (id: number) => {
  tenantIntegrationStore.deleteTenantIntegrationOrganization(tenantId.value, integration.value.id, id);
};

return (_ctx: any,_cache: any) => {
  const _component_ActionMenu = _resolveComponent("ActionMenu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ActionMenu, {
      "menu-items": createMenuModel(_unref(data)),
      icon: "more_horiz"
    }, null, 8, ["menu-items"])
  ]))
}
}

})